<template>
  <div>
    <div v-if="loading">
      <spinner small />
    </div>

    <template v-else>
      <v-btn fab small icon v-if="deleteOnly" @click="deleteFile">
        <v-icon color="appMain">delete</v-icon>
      </v-btn>

      <dropdown-menu-button
        v-else-if="filteredActions.length"
        :direction="direction"
      >
        <v-list>
          <v-list-item
            v-for="(action, idx) in filteredActions"
            :key="idx"
            @click="handleAction(action)"
          >
            <v-list-item-title>
              {{ action.text }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </dropdown-menu-button>
    </template>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import EventBus from '@/factories/eventBus';

export default {
  name: 'FileFolderControls',
  props: {
    file: {
      type: Object,
      default: () => ({}),
    },
    direction: String,
    viewOnly: Boolean,
    deleteOnly: Boolean,
    gallery: Boolean,
  },
  data() {
    return {
      loading: false,
      actions: [
        {
          text: 'Edit',
          action: 'editFile',
          check: (file) => !file.system && !this.viewOnly,
        },
        {
          text: 'View',
          action: 'viewFile',
          check: () => !this.gallery,
        },
        {
          text: 'Download',
          action: 'downloadFile',
          check: (file) => !file.system && !this.gallery,
        },
        {
          text: 'Delete',
          action: 'openDeleteConfirmation',
          check: (file) => !file.system && !this.viewOnly,
        },
      ],
    };
  },
  computed: {
    filteredActions() {
      return this.actions.filter((action) => {
        if (action.check) {
          return action.check(this.file);
        }
        return true;
      });
    },
  },
  methods: {
    ...mapActions('files', ['deleteOne']),
    ...mapMutations('fileFolders', ['removeFileFromFolder']),

    handleAction({ action }) {
      if (!this[action]) return;
      this[action]();
    },

    openDeleteConfirmation() {
      this.openConfirmationModal({
        title: 'Delete File',
        text: 'Are you sure you want to delete this file?',
        onConfirm: async () => {
          await this.deleteFile();
        },
      });
    },

    async deleteFile() {
      const { id, folder_id } = this.file;

      this.loading = true;
      try {
        await this.deleteOne({ id });
        if (folder_id) {
          this.removeFileFromFolder({ folder_id, id });
        }
      } finally {
        this.loading = false;
      }
    },

    async downloadFile() {
      try {
        const { url, filename = 'download', extension } = this.file;

        let baseName = filename.replace(/\.[^/.]+$/, '');
        const ext = extension ? extension.replace(/^\./, '') : '';
        const fullName = ext ? `${baseName}.${ext}` : baseName;

        const response = await fetch(url);
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const link = Object.assign(document.createElement('a'), {
          href: blobUrl,
          download: fullName,
        });

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error('Download failed:', error);
      }
    },

    viewFile() {
      EventBus.$emit('openFileViewer', this.file);
    },

    editFile() {
      EventBus.$emit('openFileForm', { id: this.file.id });
    },
  },
};
</script>
